import React from 'react';
import PropTypes from 'prop-types';
import { TrackingClient } from '@sparefoot/tracking-client';
import { omit } from 'lodash';

const withFormTracking = (Component) => {
	const WithFormTracking = (props) => {
		const handleSubmit = (evt) => {
			evt.stopPropagation();
			evt.preventDefault();

			const form = evt.target;
			const formData = new FormData(form);
			const trackingData = {
				form_id: form.id || props.id || form.className || '',
				form_target: form.action,
				form_url: form?.baseURI,
				email: formData.get('email') || undefined,
				first_name:
					formData.get('firstName') ||
					formData.get('alternateFirstNames') ||
					undefined,
				last_name:
					formData.get('lastName') ||
					formData.get('alternateLastNames') ||
					undefined,
			};

			TrackingClient?.trackFormSubmitted(trackingData);

			return Promise.resolve(props.onSubmit(evt));
		};

		const cleanedProps = omit(props, [
			'invalid',
			'successLabel',
			'failureLabel',
		]);

		return (
			<Component
				{...cleanedProps}
				onSubmit={handleSubmit}
			/>
		);
	};
	WithFormTracking.displayName = `withFormTracking(${Component.displayName || Component.name || 'Component'})`;
	WithFormTracking.propTypes = {
		id: PropTypes.string,
		onSubmit: PropTypes.func,
	};
	return WithFormTracking;
};

export default withFormTracking;
